import uniqolor from "uniqolor"

export function getUserColor(userId: string): {
  color: string
  isLight: boolean
} {
  return uniqolor(userId, { format: "hex" })
}
